"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPolygon = exports.p = exports.pixelize = void 0;
const pixelize = (val) => val ? `${parseInt(String(val))}px` : '0px';
exports.pixelize = pixelize;
exports.p = exports.pixelize;
const createPolygon = ({ afterStyles, childStyles, beforeStyles, bgcolor = 'background.paper', borderColor = 'border', rootStyles, strokeWidth = 1, }) => {
    return Object.assign(Object.assign({ position: 'relative' }, rootStyles), { '& > *:not(.MuiAutocomplete-loading):first-of-type': Object.assign({}, childStyles), '& > *:first-of-type': {
            '&:before': Object.assign({ backgroundColor: borderColor, bottom: 0, content: '""', left: 0, position: 'absolute', right: 0, top: 0, zIndex: -2 }, beforeStyles),
            '&:after': Object.assign({ backgroundColor: bgcolor, bottom: strokeWidth, content: '""', left: strokeWidth, overflow: 'hidden', position: 'absolute', right: strokeWidth, top: strokeWidth, zIndex: -1 }, afterStyles),
        } });
};
exports.createPolygon = createPolygon;
